import api from '@services/api';
import {
  PersonAllocation,
  ProjectRequest,
  ProviderRequest,
  ProviderResponse,
  ProviderSearchRequest,
} from '../models/providersResponse';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const ProviderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listAllProviderByPeriod: builder.query<ProviderResponse[], string>({
      query: (period: string) => ({
        url: `/indirect/provider-sharing-config/listAllByPeriod?period=${period}`,
        method: 'GET',
        providesTags: ['listAllProviderByPeriod'],
      }),
    }),
    listAllByPeriodAndProvider: builder.query<PersonAllocation[], ProviderRequest>({
      query: (request: ProviderRequest) => ({
        url: `/indirect/provider-sharing-config-detail/listAllByPeriodAndProvider?period=${request.date}&providerId=${request.id}`,
        method: 'GET',
        providesTags: ['listAllProviderByPeriodAndProvider'],
      }),
    }),
    AddProjects: builder.mutation<PersonAllocation, ProjectRequest>({
      query: (input) => ({
        url: `/indirect/provider-sharing-config/addExtraValue`,
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['listAllProviderByPeriod', 'listAllProviderByPeriodAndProvider', 'Projects'],
    }),
    exportProvider: builder.mutation<void, string>({
      query: (period) => ({
        url: `/indirect/provider-sharing-config/export?period=${period}`,
        method: 'POST',
      }),
      invalidatesTags: ['PeriodFile'],
    }),
    listProviderSearchTerm: builder.query<ProviderResponse[], ProviderSearchRequest>({
      query: (request: ProviderSearchRequest) => ({
        url: `/indirect/provider-sharing-config/searchBy?period=${request.date}&searchTerm=${request.searchTerm}&branch=${request.branch}`,
        method: 'GET',
        providesTags: ['listAllProviderByPeriod'],
      }),
    }),
  }),
});

export const {
  useListAllProviderByPeriodQuery,
  useListAllByPeriodAndProviderQuery,
  useAddProjectsMutation,
  useExportProviderMutation,
  useListProviderSearchTermQuery,
} = ProviderApi;
